import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#1e82cf"
      },
      dark: {
        primary: "#1591d9"
      }
    }
  }
});
